import React, { useEffect, useState } from 'react';
import { FormInputRadio } from '../../formInputsV2/FormInputRadio';
import OffcanvasForm from '../../componentsV2/elements/OffcanvasForm';
import { FormInputSelect } from '../../formInputsV2/FormInputSelect';
import { FormInputAddressComplete } from '../../formInputsV2/FormInputAddressComplete';
import FormReactSelectInputBirthPlace from '../../formInputsV2/FormReactSelectInputBirthPlace';
import { FormInputDate } from '../../formInputsV2/FormInputDate';
import { FormInputText } from '../../formInputsV2/FormInputText';
import { flagResponse, genders } from '../../constants';
import getMaxAllowedBirthday from '../../helpers/getMaxAllowedBirthday';
import getAllowedLicenseYears from '../../helpers/getAllowedLicenseYears';
import { FormInputAddressCompleteManual } from '../../formInputsV2/FormInputAddressCompleteManual';
import getMinAllowedBirthday from '../../helpers/getMinAllowedBirthday';
import { validateItalianPostCode } from '../../validators';
import { FormLayout } from '../../formInputsV2/FormLayout.styles';
import CollapsiblePanel from '../../formInputsV2/CollapsiblePanel';

function RcVanStepTwo({
  register,
  errors,
  answers,
  municipalities,
  states,
  formData,
  isValid,
  updateFormData,
  driverFormComponentRef,
  driverForm,
  setDriverForm,
  driver,
  updateDriverFormData,
  ownerFormComponentRef,
  ownerForm,
  setOwnerForm,
  owner,
  updateOwnerFormData,
  showStepTwoFields = false,
  setShowStepTwoFields = () => {},
}) {
  const [showManualAdress, setShowManualAdress] = useState(false);
  const [showBirthDateLicense, setShowBirthDateLicense] = useState(true);
  const [showExistingCustomer, setShowExistingCustomer] = useState(true);

  useEffect(() => {
    if (answers.date_of_birth !== '' && answers.renew_check === true) {
      setShowBirthDateLicense(false);
    }

    if (answers.gender !== '' && answers.renew_check === true) {
      setShowExistingCustomer(false);
    }
  }, []);

  return (
    <FormLayout id="datiPersonali">

      {(showExistingCustomer || errors.gender?.message) && (
        <FormInputRadio
          label="Il contraente è"
          options={genders}
          name="gender"
          registration={register('gender')}
          error={errors.gender?.message}
        />
      )}

      {answers.gender === 'G' && (
        <>
          <FormInputText
            registration={register('business_name')}
            error={errors.business_name?.message}
            valid={isValid('business_name')}
            label="Ragione sociale"
            placeholder="Inserisci la ragione sociale"
          />
          <FormInputText
            registration={register('vat_number')}
            error={errors.vat_number?.message}
            valid={isValid('vat_number')}
            label="Partita Iva"
            placeholder="Inserisci la partita IVA"
          />
          <FormInputSelect
            label="Tipologia azienda"
            registration={register('company_type')}
            error={errors.company_type?.message}
            valid={isValid('company_type')}
            placeholder="-Seleziona-"
            options={formData.company_types}
          />
        </>
      )}
      {answers.gender !== 'G' && (
        <>
          <FormInputText
            registration={register('name')}
            error={errors.name?.message}
            valid={isValid('name')}
            label="Nome"
            placeholder="Inserisci il nome"
          />
          <FormInputText
            registration={register('surname')}
            error={errors.surname?.message}
            valid={isValid('surname')}
            label="Cognome"
            placeholder="Inserisci il cognome"
          />
          {(showBirthDateLicense || errors.date_of_birth?.message) && (
            <FormInputDate
              label="Data di nascita"
              registration={register('date_of_birth')}
              minDate={getMinAllowedBirthday()}
              maxDate={getMaxAllowedBirthday()}
              error={errors.date_of_birth?.message}
              valid={isValid('date_of_birth')}
            />
          )}
          {((answers.date_of_birth !== '') && (showBirthDateLicense || errors.driving_license_year?.message)) && (
            <FormInputSelect
              label="Anno patente"
              registration={register('driving_license_year')}
              error={errors.driving_license_year?.message}
              valid={isValid('driving_license_year')}
              placeholder="-Seleziona-"
              options={getAllowedLicenseYears(answers.date_of_birth)}
            />
          )}
          <FormReactSelectInputBirthPlace
            states={states}
            options={municipalities}
            label="Luogo di nascita"
            name="commune_of_birth_code"
            values={{
              commune_of_birth_code: answers.commune_of_birth_code,
              province_of_birth_code: answers.province_of_birth_code,
              born_abroad: answers.born_abroad,
              country_of_birth_code: answers.country_of_birth_code,
            }}
            onChange={(value) => updateFormData({
              commune_of_birth_code: value.commune_of_birth_code,
              province_of_birth_code: value.province_of_birth_code,
              born_abroad: value.born_abroad,
              country_of_birth_code: value.country_of_birth_code,
            })}
            valid={isValid('commune_of_birth_code')}
            error={errors.commune_of_birth_code?.message}
            valid_country_of_birth_code={isValid('country_of_birth_code')}
            error_country_of_birth_code={errors.country_of_birth_code?.message}
          />
        </>
      )}

      {showManualAdress ? (
        <FormInputAddressCompleteManual
          municipalities={municipalities}
          formData={answers}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
        />
      ) : (
        <FormInputAddressComplete
          showManualAdress={showManualAdress}
          municipalities={municipalities}
          formData={answers}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
          addressId="autocomplete-address-contractor"
          setShow={setShowManualAdress}
        />
      )}

      {answers.gender !== 'G' && (
        <FormInputRadio
          label="Il contraente è anche il conducente abituale del veicolo?"
          options={flagResponse}
          name="contractor_is_driver"
          registration={register('contractor_is_driver')}
          error={errors.contractor_is_driver?.message}
        />
      )}

      {answers.contractor_is_driver === '0' ? (
        <OffcanvasForm
          ref={driverFormComponentRef}
          filled={driverForm}
          setFilled={setDriverForm}
          id="dati-driver"
          title="Dati Del Conduttore"
          data={driver}
          onChange={updateDriverFormData}
          genders={genders}
          getMaxAllowedBirthday={getMaxAllowedBirthday}
          municipalities={municipalities}
          validateItalianPostCode={validateItalianPostCode}
          marital_statuses={formData.marital_statuses}
          qualifications={formData.qualifications}
          professions={formData.professions}
          company_types={formData.company_types}
          isOwnerForm={false}
          states={states}
        />
      ) : (
        ''
      )}

      {answers.gender !== 'G' && (
        <FormInputRadio
          label="Il contraente è anche proprietario dell auto?"
          options={flagResponse}
          name="contractor_is_owner"
          registration={register('contractor_is_owner')}
          error={errors.contractor_is_owner?.message}
        />
      )}

      {answers.contractor_is_owner === '0' ? (
        <OffcanvasForm
          ref={ownerFormComponentRef}
          filled={ownerForm}
          states={states}
          setFilled={setOwnerForm}
          id="dati-proprietario"
          title="Dati Del Proprietario"
          data={owner}
          onChange={updateOwnerFormData}
          genders={genders}
          getMaxAllowedBirthday={getMaxAllowedBirthday}
          municipalities={municipalities}
          validateItalianPostCode={validateItalianPostCode}
          marital_statuses={formData.marital_statuses}
          qualifications={formData.qualifications}
          professions={formData.professions}
          company_types={formData.company_types}
          isOwnerForm
        />
      ) : (
        ''
      )}

      {answers.gender !== 'G' && (
        <>
          <hr />
          <CollapsiblePanel
            open={showStepTwoFields}
            onToggle={() => setShowStepTwoFields(!showStepTwoFields)}
          >
            <FormInputRadio
              label="Figli conviventi?"
              options={flagResponse}
              name="children"
              registration={register('children')}
              error={errors.children?.message}
            />
            <FormInputSelect
              placeholder="Stato civile"
              label="Stato civile"
              registration={register('civil_status_id')}
              error={errors.civil_status_id?.message}
              valid={isValid('civil_status_id')}
              options={formData.marital_statuses}
            />
            <FormInputSelect
              placeholder="Titolo di studio"
              label="Titolo di studio"
              registration={register('education_level_id')}
              error={errors.education_level_id?.message}
              valid={isValid('education_level_id')}
              options={formData.qualifications}
            />
            <FormInputSelect
              placeholder="Professione"
              label="Professione"
              registration={register('profession_id')}
              error={errors.profession_id?.message}
              valid={isValid('profession_id')}
              options={formData.professions}
            />
          </CollapsiblePanel>
        </>
      )}

    </FormLayout>
  );
}

export default RcVanStepTwo;
